<script setup lang="ts">
import { AwSkeleton } from "@asap/design";
import type { KpiTile } from "./types";

const SKELETON_TILE_COUNT = 1;

withDefaults(
  defineProps<{
    title?: string;
    kpis?: KpiTile[];
    trendLabel?: string;
    loading?: boolean;
  }>(),
  { title: "Productivité", kpis: undefined, trendLabel: undefined, loading: false }
);

const ui = {
  kpiGrid: "grid grid-cols-1 gap-2",
  trend: "flex flex-col gap-1",
  trendLabel: "text-sm text-secondary-700",
  trendChart: "w-full min-w-0 rounded-lg border border-secondary-200 p-2",
  skeletonTrendLabel: "h-3.5 w-28",
  skeletonChart: "h-[150px] w-full rounded-lg",
};
</script>

<template>
  <ConsultantKpiCard :title="title">
    <div :class="ui.kpiGrid">
      <template v-if="loading">
        <ConsultantKpiTile
          v-for="index in SKELETON_TILE_COUNT"
          :key="`productivity-skeleton-${index}`"
          loading
          variant="plain"
        />
      </template>
      <template v-else>
        <ConsultantKpiTile v-for="kpi in kpis" :key="kpi.label" v-bind="kpi" variant="plain" />
      </template>
    </div>

    <div :class="ui.trend">
      <AwSkeleton v-if="loading" :class="ui.skeletonTrendLabel" />
      <span v-else :class="ui.trendLabel">{{ trendLabel }}</span>
      <AwSkeleton v-if="loading" :class="ui.skeletonChart" />
      <div v-else :class="ui.trendChart">
        <slot></slot>
      </div>
    </div>
  </ConsultantKpiCard>
</template>
